import React from 'react';
import { Spin, Modal, List, Button, Flex, Typography, Space, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { UserWithRole, Invitation } from '../../types';
import TgAvatar from './TgAvatar';
import { useGetTaskActivitiesQuery } from '../store/tasks';

import { TASK_STATUS, TODO_ACTIVITY_TYPES, PRIORITIES } from '../constants';

import type { Activity } from '../../types';

const { Text, Title } = Typography;

interface TaskActivitiesProps {
    open: boolean;
    onClose: () => void;
    taskId: number;
}

const TaskActivities: React.FC<TaskActivitiesProps> = ({
    open,
    onClose,
    taskId,
}) => {
    const { data, isLoading, error } = useGetTaskActivitiesQuery({ taskId });

    if (isLoading) {
        return <Spin />;
    }

    if (error || !data) {
        return <div>:(</div>;
    }

    const activities = data.message;

    const messages = [
        'добавил(а) задачу',
        'изменил(а) задачу',
        'удалил(а) задачу',
        'удалил(а) изображение',
        'добавил(а) изображение',
        'обновил(а) статус',
        'обновил(а) теги',
        'добавил(а) ссылку',
        'удалил(а) ссылку',
        'добавил(а) комментарий',
        'изменил(а) приоритет',
    ];

    const getMessage = (activity: Activity): string => {
        let message = `${ activity.user.firstName } `;

        if (+activity.type === TODO_ACTIVITY_TYPES.updatePriority && activity.meta && !activity.meta.priority) {
            message += 'удалил(а) приоритет';
            return message;
        }

        message += `${ messages[activity.type - 1] || ''}`;

        if (+activity.type === TODO_ACTIVITY_TYPES.updateStatus && activity.meta && activity.meta.status) {
            message += ` на «${ TASK_STATUS[activity.meta.status] }»`;
        }
        if (+activity.type === TODO_ACTIVITY_TYPES.updatePriority && activity.meta && activity.meta.priority) {
            message += ` на «${ PRIORITIES[activity.meta.priority] }»`;
        }

        return message;
    };

    return (
        <Modal
            title="История"
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <Flex vertical gap="large" style={{ maxHeight: 'calc(100vh - 200px', overflow: 'auto' }}>
                <List
                    dataSource={activities}
                    renderItem={(activity) => (
                        <List.Item
                            actions={[
                                <div>
                                    <div style={{ fontWeight: 400, opacity: 0.5, lineHeight: 1 }}>
                                        <Text>
                                            {new Date(activity.createDate).toLocaleString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'})}
                                        </Text>
                                    </div>
                                </div>,
                            ]}
                        >
                            <Space>
                                <TgAvatar
                                    user={activity.user}
                                />

                                <strong>
                                    { getMessage(activity) }
                                </strong>
                            </Space>
                        </List.Item>
                    )}
                />
            </Flex>
        </Modal>
    );
};

export default TaskActivities;
